// src/utils/web3.js

import Web3 from "web3";

import NFTMarketplace from "../contracts/build/NFTMarketplace.json"; // Replace with the actual path to your ABI JSON file

// const web3 = new Web3("http://localhost:8545"); // Use your Ganache RPC URL
export const web3 = new Web3(window.ethereum);
// chain
export const contractAddress = "0x98771AA279a64b051abC6c2fEC53C5D4D43D1d4A";

// local
// export const contractAddress = "0xA627F114d5Fe2ceE7531c1A8bE679c05D5FB3Ad4";

export const nftContract = new web3.eth.Contract(
  NFTMarketplace.abi,
  contractAddress
);

// Convert Ether to Wei
const ethToWei = (eth) => {
  return web3.utils.toWei(eth.toString(), "ether");
};

// Convert Wei to Ether
export const weiToEth = (wei) => {
  return web3.utils.fromWei(wei.toString(), "ether");
};

const isValidAddress = (address) => {
  // Regular expression to match a valid Ethereum address
  const addressRegex = /^(0x)?[0-9a-fA-F]{40}$/;

  // Check if the provided address matches the pattern
  return addressRegex.test(address);
}

function daysToSeconds(days) {
  // 1 day has 24 hours, 1 hour has 60 minutes, and 1 minute has 60 seconds
  const secondsInADay = 24 * 60 * 60;
  const seconds = days * secondsInADay;
  return seconds;
}

export function secondsToDays(seconds) {
  // 1 day has 24 hours, 1 hour has 60 minutes, and 1 minute has 60 seconds
  const secondsInADay = 24 * 60 * 60;
  const days = seconds / secondsInADay;
  return days;
}

export function convertUnixTimestampToDate(endTime) {
  // Create a new JavaScript Date object
  const date = new Date(endTime * 1000); // Multiply by 1000 to convert from seconds to milliseconds

  // Define the desired date format (e.g., "YYYY-MM-DD HH:MM:SS")
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };

  // Format the date
  const formattedDate = date.toLocaleString(undefined, options);

  return formattedDate;
}

export const fetchFixedListings = async () => {
  try {
    const allListings = await nftContract.methods.getAllListings().call();

    // console.log(allListings);
    const listingData = await Promise.all(
      allListings.map(async (listing) => {
        if (listing.active) {

          const tokenURI = await nftContract.methods
            .getTokenURI(listing.tokenId)
            .call();
          const response = await fetch(tokenURI);
          const metadata = await response.json();
          // console.log(weiToEth(listing.price));

          return {
            [listing.tokenId]: {
              ...metadata,
              listed: true,
              price: weiToEth(listing.price),
              seller: listing.seller,
            },
          };
        }
      })
    );

    const nftDataObject = [...listingData].reduce((result, item) => {
      return { ...result, ...item };
    }, {});

    return nftDataObject;
  } catch (error) {
    console.warn("Fetching NFTs Failed");
  }
};

export const fetchAuctions = async () => {
  try {
    const allAuctions = await nftContract.methods.getCurrentAuctions().call();

    // console.log(allListings);
    const auctionData = await Promise.all(
      allAuctions.map(async (auction) => {
        if (auction.active) {

          const tokenURI = await nftContract.methods
            .getTokenURI(auction.tokenId)
            .call();
          const response = await fetch(tokenURI);
          const metadata = await response.json();

          return {
            [auction.tokenId]: {
              ...metadata,
              auctioned: true,
              startingPrice: weiToEth(auction.startingPrice),
              currentPrice: parseInt(auction.highestBid) !== 0 ? weiToEth(auction.highestBid) : weiToEth(auction.startingPrice),
              seller: auction.seller,
              highestBidder: parseInt(auction.highestBid) !== 0 ? auction.highestBidder : auction.seller,
              duration: secondsToDays(parseInt(auction.duration)),
              endTime: convertUnixTimestampToDate(parseInt(auction.endTime))
            },
          };
        } else {
          return {}; // Return an empty object for inactive auctions
        }
      })
    );

    const auctionDataObject = [...auctionData].reduce((result, item) => {
      return { ...result, ...item };
    }, {});

    return auctionDataObject;
  } catch (error) {
    console.warn("Fetching auctions Failed");
  }
};

export const listNFT = async (address, tokenId, price) => {
  // Check if the price is 0
  if (price <= 0) {
    alert("Price must be greater than 0.");
    return false;
  }
  try {
    price = ethToWei(price);
    const gasPrice = await web3.eth.getGasPrice();
    const gasEstimate = await nftContract.methods
      .listNFT(tokenId, price)
      .estimateGas({ from: address });

    const tx = {
      from: address,
      to: contractAddress,
      gas: parseInt(gasEstimate),
      gasPrice: gasPrice,
      data: nftContract.methods.listNFT(tokenId, price).encodeABI(),
    };

    const listed = await web3.eth
      .sendTransaction(tx)
      .on("transactionHash", async function (hash) {
        // console.log('Transaction Hash:', hash);
      })
      .on("confirmation", async function (confirmationNumber, receipt) {
        // console.log('Confirmation Number:', confirmationNumber);
        // console.log('Receipt:', receipt);
        alert("NFT listed successfully!");
        return true;
      })
      .on("error", function (error) {
        console.error("Error:", error);
        return false;
      });

    if (listed) {
      return true;
    }

    // Listing was successful, you can show a success message or perform other actions.
  } catch (error) {
    // Handle errors here
    if (error.message) {
      // Handle specific error messages, e.g., if the transaction was rejected by the user or price is 0.
      if (error.message.includes("User denied transaction")) {
        // Notify the user that the transaction was denied
        alert("Transaction was denied by the user.");
        return false;
      } else {
        // Handle other error messages
        console.error("Error while listing NFT:", error.message);
      }
    } else {
      // Handle general errors
      console.error("An error occurred while listing NFT:", error);
    }
    return false;
  }
};

export const unlistNFT = async (address, tokenId) => {
  try {
    const gasPrice = await web3.eth.getGasPrice();
    const gasEstimate = await nftContract.methods
      .unlistNFT(tokenId)
      .estimateGas({ from: address });
    // alert('working', gasEstimate)

    const tx = {
      from: address,
      to: contractAddress,
      gas: parseInt(gasEstimate),
      gasPrice: gasPrice,
      data: nftContract.methods.unlistNFT(tokenId).encodeABI(),
    };

    const unlisted = await web3.eth
      .sendTransaction(tx)
      .on("transactionHash", async function (hash) {
        console.log('Transaction Hash:', hash);
      })
      .on("confirmation", async function (confirmationNumber, receipt) {
        // console.log('Confirmation Number:', confirmationNumber);
        console.log('Receipt:', receipt);
        alert("NFT unlisted successfully!");
        return false;
      })
      .on("error", function (error) {
        console.error("Error:", error);
        return true;
      });

    if (unlisted) {
      return false;
    }
    // Unlisting was successful, you can show a success message or perform other actions.
  } catch (error) {
    // Handle errors here
    if (error.message) {
      // Handle specific error messages, e.g., if the transaction was rejected by the user or price is 0.
      if (error.message.includes("User denied transaction")) {
        // Notify the user that the transaction was denied
        alert("Transaction was denied by the user.");
        return true;
      } else {
        // Handle other error messages
        console.error("Error while unlisting NFT:", error.message);
        return true;
      }
    } else {
      // Handle general errors
      console.error("An error occurred while unlisting NFT:", error);
      return true;
    }
  }
};

export const buyNFT = async (address, tokenId, price) => {
  if (!address) {
    alert("Please connect your wallet to buy this nft");
    return false;
  }

  try {
    price = ethToWei(price);
    const gasPrice = await web3.eth.getGasPrice();
    const gasEstimate = await nftContract.methods
      .purchaseNFT(tokenId)
      .estimateGas({ from: address, value: price });

    const tx = {
      from: address,
      value: price,
      to: contractAddress,
      gas: parseInt(gasEstimate),
      gasPrice: gasPrice,
      data: nftContract.methods.purchaseNFT(tokenId).encodeABI(),
    };

    const buy = await web3.eth
      .sendTransaction(tx)
      .on("transactionHash", async function (hash) {
        // console.log('Transaction Hash:', hash);
      })
      .on("confirmation", async function (confirmationNumber, receipt) {
        // console.log('Confirmation Number:', confirmationNumber);
        // console.log('Receipt:', receipt);
        alert("NFT bought successfully!");
        return true;
      })
      .on("error", function (error) {
        console.error("Error:", error);
        return false;
      });

    if (buy) {
      return true;
    }

    // Listing was successful, you can show a success message or perform other actions.
  } catch (error) {
    // Handle errors here
    if (error.message) {
      // Handle specific error messages, e.g., if the transaction was rejected by the user or price is 0.
      if (error.message.includes("User denied transaction")) {
        // Notify the user that the transaction was denied
        alert("Transaction was denied by the user.");
        return false;
      } else {
        // Handle other error messages
        console.error("Error while buying NFT:", error.message);
      }
    } else {
      // Handle general errors
      console.error("An error occurred while buying NFT:", error);
    }
    return false;
  }
};

export const giftNFT = async (address, giftAddress, tokenId) => {
  if (!address) {
    alert("Please connect your wallet to gift this nft");
    return false;
  }

  if (!giftAddress) {
    alert("The receiver's address can't be empty");
    return false;
  } else if (!isValidAddress(giftAddress)) {
    alert("Invalid Ethereum address. Please enter a valid MetaMask address.");
    return false;
  }

  if (address === giftAddress) {
    alert("Cannot gift NFT to yourself");
    return false;
  }

  try {
    const gasPrice = await web3.eth.getGasPrice();
    const gasEstimate = await nftContract.methods
      .giftNFT(tokenId, giftAddress)
      .estimateGas({ from: address });

    const tx = {
      from: address,
      to: contractAddress,
      gas: parseInt(gasEstimate),
      gasPrice: gasPrice,
      data: nftContract.methods.giftNFT(tokenId, giftAddress).encodeABI(),
    };

    const gift = await web3.eth
      .sendTransaction(tx)
      .on("transactionHash", async function (hash) {
        // console.log('Transaction Hash:', hash);
      })
      .on("confirmation", async function (confirmationNumber, receipt) {
        // console.log('Confirmation Number:', confirmationNumber);
        // console.log('Receipt:', receipt);
        alert("NFT gifted successfully!");
        return true;
      })
      .on("error", function (error) {
        console.error("Error:", error);
        return false;
      });

    if (gift) {
      return true;
    }

    // Listing was successful, you can show a success message or perform other actions.
  } catch (error) {
    // Handle errors here
    if (error.message) {
      // Handle specific error messages, e.g., if the transaction was rejected by the user or price is 0.
      if (error.message.includes("User denied transaction")) {
        // Notify the user that the transaction was denied
        alert("Transaction was denied by the user.");
        return false;
      } else {
        // Handle other error messages
        console.error("Error while gifting NFT:", error.message);
      }
    } else {
      // Handle general errors
      console.error("An error occurred while gifting NFT:", error);
    }
    return false;
  }
};

export const startAuction = async (address, tokenId, startingPrice, duration) => {

  // Check if the price is 0
  if (startingPrice <= 0) {
    alert("Starting Price must be greater than 0.");
    return false;
  }

  // Check if the duration is 0
  if (duration <= 0) {
    alert("Duration must be a minimum of 1 day.");
    return false;
  }

  // Check if the duration is greater than 7
  if (duration > 7) {
    alert("Duration must be a maximum of 7 days.");
    return false;
  }

  try {
    startingPrice = ethToWei(startingPrice);
    duration = daysToSeconds(duration)
    const gasPrice = await web3.eth.getGasPrice();
    const gasEstimate = await nftContract.methods
      .startAuction(tokenId, startingPrice, duration)
      .estimateGas({ from: address });

    const tx = {
      from: address,
      to: contractAddress,
      gas: parseInt(gasEstimate),
      gasPrice: gasPrice,
      data: nftContract.methods.startAuction(tokenId, startingPrice, duration).encodeABI(),
    };

    const auctionStarted = await web3.eth
      .sendTransaction(tx)
      .on("transactionHash", async function (hash) {
        // console.log('Transaction Hash:', hash);
      })
      .on("confirmation", async function (confirmationNumber, receipt) {
        // console.log('Confirmation Number:', confirmationNumber);
        // console.log('Receipt:', receipt);
        alert("Auction created successfully!");
        return true;
      })
      .on("error", function (error) {
        console.error("Error:", error);
        return false;
      });

    if (auctionStarted) {
      return true;
    }

    // Listing was successful, you can show a success message or perform other actions.
  } catch (error) {
    // Handle errors here
    if (error.message) {
      // Handle specific error messages, e.g., if the transaction was rejected by the user or price is 0.
      if (error.message.includes("User denied transaction")) {
        // Notify the user that the transaction was denied
        alert("Transaction was denied by the user.");
        return false;
      } else {
        // Handle other error messages
        console.error("Error while creating auction:", error.message);
      }
    } else {
      // Handle general errors
      console.error("An error occurred while listing NFT:", error);
    }
    return false;
  }
}

export const bidAuction = async (address, tokenId, price, currentPrice) => {

  if (!address) {
    alert("Please connect your wallet to buy this nft");
    return false;
  }

  if (price <= 0) {
    alert("Price should be Greater than 0.");
    return false;
  }

  if (price <= currentPrice) {
    alert("Price should be Greater than " + currentPrice);
    return false;
  }

  try {
    price = ethToWei(price);
    const gasPrice = await web3.eth.getGasPrice();
    const gasEstimate = await nftContract.methods
      .placeBid(tokenId)
      .estimateGas({ from: address, value: price });

    const tx = {
      from: address,
      value: price,
      to: contractAddress,
      gas: parseInt(gasEstimate),
      gasPrice: gasPrice,
      data: nftContract.methods.placeBid(tokenId).encodeABI(),
    };

    const bid = await web3.eth
      .sendTransaction(tx)
      .on("transactionHash", async function (hash) {
        // console.log('Transaction Hash:', hash);
      })
      .on("confirmation", async function (confirmationNumber, receipt) {
        // console.log('Confirmation Number:', confirmationNumber);
        // console.log('Receipt:', receipt);
        alert("Bid placed successfully!");
        return true;
      })
      .on("error", function (error) {
        console.error("Error:", error);
        return false;
      });

    if (bid) {
      return true;
    }

    // Listing was successful, you can show a success message or perform other actions.
  } catch (error) {
    // Handle errors here
    if (error.message) {
      // Handle specific error messages, e.g., if the transaction was rejected by the user or price is 0.
      if (error.message.includes("User denied transaction")) {
        // Notify the user that the transaction was denied
        alert("Transaction was denied by the user.");
        return false;
      } else {
        // Handle other error messages
        console.error("Error while initiating bid:", error.message);
      }
    } else {
      // Handle general errors
      console.error("An error occurred while bidding:", error);
    }
    return false;
  }

}

export const cancelAuction = async (address, tokenId) => {

  try {
    const gasPrice = await web3.eth.getGasPrice();
    const gasEstimate = await nftContract.methods
      .cancelAuction(tokenId)
      .estimateGas({ from: address });

    const tx = {
      from: address,
      to: contractAddress,
      gas: parseInt(gasEstimate),
      gasPrice: gasPrice,
      data: nftContract.methods.cancelAuction(tokenId).encodeABI(),
    };

    const auctionStarted = await web3.eth
      .sendTransaction(tx)
      .on("transactionHash", async function (hash) {
        // console.log('Transaction Hash:', hash);
      })
      .on("confirmation", async function (confirmationNumber, receipt) {
        // console.log('Confirmation Number:', confirmationNumber);
        // console.log('Receipt:', receipt);
        alert("Auction cancelled successfully!");
        return false;
      })
      .on("error", function (error) {
        console.error("Error:", error);
        return true;
      });

    if (auctionStarted) {
      return false;
    }

    // Listing was successful, you can show a success message or perform other actions.
  } catch (error) {
    // Handle errors here
    if (error.message) {
      // Handle specific error messages, e.g., if the transaction was rejected by the user or price is 0.
      if (error.message.includes("User denied transaction")) {
        // Notify the user that the transaction was denied
        alert("Transaction was denied by the user.");
        return true;
      } else {
        // Handle other error messages
        console.error("Error while cancelling auction:", error.message);
      }
    } else {
      // Handle general errors
      console.error("An error occurred while cancelling auction:", error);
    }
    return true;
  }

}

export const autoFinalizeAuctions = async () => {

  try {
    const finalizeAuctions = await nftContract.methods.checkAndFinalizeAuctions().call();

    if (finalizeAuctions) {
      return true;
    }
  } catch (error) {
    console.warn("Finalizing Auctions Failed");
    return false;
  }
}
